import { EMR_APIS } from "@/api_framework/api_config";

import { IEMRUpdateResponse } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useEMRDeleteAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (emrId: string, cartId: string) => {
      dispatch(
        setLoading({
          key: "isEMRUpdateInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: string = await axios
          .delete(`${EMR_APIS?.UPDATE_EMR?.baseURL}${emrId}/${cartId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IEMRUpdateResponse>) => {
            dispatch(
              setLoading({
                key: "isEMRUpdateInProgress",
                status: false,
              }),
            );
            if (res.data.status === true && res.data) {
              toast.success("EMR Deleted Successfully");
              return res.data.data;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isEMRUpdateInProgress",
                status: false,
              }),
            );

            captureError(e);
            return null;
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isEMRUpdateInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
